// Revisão espaçada SM-2 (F3) — por TÓPICO concluído, não flashcard.
// Cada conteúdo 'done' entra na rotação: 1ª revisão D+1, depois D+6,
// depois intervalo × EF. Errar reseta a sequência. Destrava a dimensão
// Aprendizado do Performance Score.

import type { Content, ReviewState } from '@app-types/domain';
import { addDaysIso } from './dates';

/** qualidades expostas na UI: 2=errei · 3=difícil · 4=bom · 5=fácil */
export type ReviewQuality = 2 | 3 | 4 | 5;

export const MIN_EASE = 1.3;

/** estado inicial ao concluir um conteúdo — 1ª revisão amanhã */
export function initialReview(todayIso: string): ReviewState {
  return {
    reps: 0,
    ease: 2.5,
    interval_days: 1,
    due_date: addDaysIso(todayIso, 1),
  };
}

/** aplica uma resposta de revisão (SM-2 clássico) */
export function answerReview(
  state: ReviewState,
  quality: ReviewQuality,
  todayIso: string,
): ReviewState {
  // EF' = EF + (0.1 - (5-q) * (0.08 + (5-q) * 0.02)), mínimo 1.3
  const q = quality;
  const ease = Math.max(MIN_EASE, state.ease + (0.1 - (5 - q) * (0.08 + (5 - q) * 0.02)));

  if (q < 3) {
    // errou: recomeça a sequência, revisa de novo amanhã
    return {
      reps: 0,
      ease,
      interval_days: 1,
      due_date: addDaysIso(todayIso, 1),
      last_quality: q,
      last_reviewed_at: new Date().toISOString(),
    };
  }

  const reps = state.reps + 1;
  const interval_days = reps === 1 ? 1 : reps === 2 ? 6 : Math.round(state.interval_days * ease);

  return {
    reps,
    ease,
    interval_days,
    due_date: addDaysIso(todayIso, interval_days),
    last_quality: q,
    last_reviewed_at: new Date().toISOString(),
  };
}

/** conteúdos com revisão vencida (due hoje ou antes), mais atrasados primeiro */
export function dueReviews(contents: Content[], todayIso: string): Content[] {
  return contents
    .filter((c) => c.review && c.review.due_date <= todayIso)
    .sort((a, b) =>
      (a.review as ReviewState).due_date.localeCompare((b.review as ReviewState).due_date),
    );
}

/** dias de atraso de uma revisão (0 = em dia) */
export function daysOverdue(review: ReviewState, todayIso: string): number {
  if (review.due_date >= todayIso) return 0;
  const due = new Date(`${review.due_date}T12:00:00`).getTime();
  const today = new Date(`${todayIso}T12:00:00`).getTime();
  return Math.round((today - due) / 86_400_000);
}
